

export class PropertyJointCostSuffix {
  static PERCENTAGE = new PropertyJointCostSuffix('%', '%');
  static PERSQM = new PropertyJointCostSuffix('perSqm', ',-/m²');
  static PERSQFT = new PropertyJointCostSuffix('perSqft', ',-/ft²');

  id: string;
  name: string;

  constructor(id: string, name: string) {
    this.id = id;
    this.name = name;
  }

  static getSuffixWithId(id: string | undefined): PropertyJointCostSuffix {
    if (id === '%') {
      return PropertyJointCostSuffix.PERCENTAGE;
    } else if (id === 'perSqm') {
      return PropertyJointCostSuffix.PERSQM;
    } else if (id === 'perSqft') {
      return PropertyJointCostSuffix.PERSQFT;
    }
    return PropertyJointCostSuffix.PERCENTAGE;
  }
}